/**
 * ユーザーエージェントによる閲覧デバイスの判定
 * @param {boolean} isToggleClassName 判定結果をルート要素に付与するかの指定
 * @return {string}
 */
export const uaDevice = isToggleClassName => {
    const ua = window.navigator.userAgent.toLowerCase()
    let device = ''
    if (ua.indexOf('mobile') != -1 ||
        ua.indexOf('iphone') != -1 ||
        ua.indexOf('ipod') != -1 ||
        ua.indexOf('ipad') != -1 ||
        ua.indexOf('android') != -1) {
        device = 'sp'
    } else {
        device = 'pc'
    }
    if (isToggleClassName) {
        const htmlClassList = document.documentElement.classList
        htmlClassList.remove('sp')
        htmlClassList.remove('pc')
        if (device !== '') {
            htmlClassList.add(device)
        }
    }
    return device
}

/**
 * ユーザーエージェントによる閲覧 OS の判定
 * @param {boolean} isToggleClassName 判定結果をルート要素に付与するかの指定
 * @return {string}
 */
export const uaOs = isToggleClassName => {
    const ua = window.navigator.userAgent.toLowerCase()
    let os = ''
    if (ua.indexOf('windows') != -1) {
        os = 'windows'
    } else if (ua.indexOf('iphone') != -1 ||
        ua.indexOf('ipod') != -1 ||
        ua.indexOf('ipad') != -1) {
        os = 'ios'
    } else if (ua.indexOf('mac') != -1) {
        os = 'mac'
    } else if (ua.indexOf('android') != -1) {
        os = 'android'
    }
    if (isToggleClassName) {
        const htmlClassList = document.documentElement.classList
        htmlClassList.remove('windows')
        htmlClassList.remove('ios')
        htmlClassList.remove('mac')
        htmlClassList.remove('android')
        if (os !== '') {
            htmlClassList.add(os)
        }
    }
    return os
}

/**
 * ユーザーエージェントによる閲覧ブラウザーの判定
 * @param {boolean} isToggleClassName 判定結果をルート要素に付与するかの指定
 * @return {string}
 */
export const uaBrowser = isToggleClassName => {
    const ua = window.navigator.userAgent.toLowerCase()
    let browser = ''
    if (ua.indexOf('safari') != -1 && ua.indexOf('chrome') == -1) {
        browser = 'safari'
    } else if (ua.indexOf('msie') != -1 || (ua.indexOf('trident') != -1 && ua.indexOf('rv:11') != -1)) {
        browser = 'ie'
    }
    if (isToggleClassName) {
        const htmlClassList = document.documentElement.classList
        htmlClassList.remove('safari')
        htmlClassList.remove('ie')
        if (browser !== '') {
            htmlClassList.add(browser)
        }
    }
    return browser
}
